<template>
  <span
    class="dark:hidden absolute rounded-full bg-[#e9effc] block size-[288px] -left-[170px] -top-[70px]"
  ></span>
  <div
    class="flex lg:items-start justify-between w-full relative z-20 max-lg:flex-col max-xl:gap-10"
  >
    <div
      v-if="whyChooseUs?.heading"
      class=" w-full lg:max-w-[45%]"
    >
      <h2 class="mt-5 font-bold leading-snug max-lg:text-center w-full ">
        <WrGradientText append-class="pb-0">
          {{ whyChooseUs?.heading }}
        </WrGradientText>
      </h2>
      <p class="text-lg mt-4  max-lg:text-center w-full font-semibold">
        {{ whyChooseUs?.subheading }}
      </p>
      <ul
        class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 max-sm:[95%] max-lg:w-[80%] max-lg:place-items-start gap-6 mt-6 max-lg:mx-auto"
      >
        <li
          v-for="item in whyChooseUs?.cardcontent"
          class="bg-[url('/images/right-single.webp')] bg-no-repeat min-w-[100px] bg-[position:0_8px] m-0 pl-[22px] text-base max-md:w-full"
        >
          {{ item?.heading }}
        </li>
      </ul>
    </div>
    <div
      class="w-full h-full max-w-max max-lg:mx-auto lg:max-w-[45%] relative z-10 lg:ml-16"
    >
      <!-- <span
        class="dark:hidden absolute rounded-full bg-[#e9effc] block size-[288px] -right-[120px] -bottom-20 z-1"
      ></span> -->
      <div
        class="absolute -left-[20px] max-lg:left-0 transform translate-y-1/2 bottom-0 bg-[#fff] dark:bg-[image:var(--bg-official-partner)] rounded-md z-10"
      >
        <div
          class="border-solid border-[#5f4ca4] dark:border-white border-l-[4px] border-t-0 border-r-0 border-b-0 rounded-[4px] py-[1.25em] px-[1.5em]"
        >
          <div class="flex items-start text-sm">
            <div class="flex-[1_1_auto]">
              <h3 class="text-[1rem] font-[700] leading-[1.125] relative">
                {{ header }}
              </h3>
              <p
                v-html="text"
                @click="handleOpenModal"
                v-if="text"
              ></p>
              <p v-else><span
                    class=" underline cursor-pointer"
                     @click="handleOpenModal"
                    >Contact Our Team</span
                  >
                  to start your professional journey </p>
            </div>
          </div>
        </div>
      </div>
      <NuxtImg
        :src="src"
        :height="height"
        :width="width"
        loading="lazy"
        class="relative"
        format="webp"
        alt="Smiling business professionals giving high five in office after successful meeting, teamwork and career growth concept"
      />
    </div>
  </div>
</template>

<script setup lang="ts">

interface CardContent {
  image_safari_ext: string;
  image: string;
  heading: string;
}

interface WhyChooseUsData {
  heading: string;
  subheading: string;
  cardcontent: CardContent[];
}

defineProps<{
  header: string;
  text?: string;
  src: string;
  height: string;
  width: string;
  whyChooseUs: WhyChooseUsData;
}>();

const emit = defineEmits<{
  (e: "openModal"): void;
}>();

const handleOpenModal = () => {
  emit("openModal");
};
</script>
